import React from 'react';
import cx from 'classnames';
import LoginLogout from './LoginLogout';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const CONTACT_US = 'https://www.pasquotankcountync.org/animal-services-contact';
const FACEBOOK = 'https://www.facebook.com/PasquotankCountyNC';
// const YOUTUBE = 'https://www.youtube.com/c/riponchannel';
// const INSTAGRAM = 'https://www.instagram.com/cityofriponwi/';
// const TIKTOK = 'https://www.tiktok.com/@cityofriponwi';
// const LINKEDIN = 'https://www.linkedin.com/company/city-of-ripon-wi/';
function Footer({ className }) {
    return (<footer className={cx('footer', className)} data-testid="footer">
      <div className="footer-wrapper">
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} Comcate, Inc.
        </p>
        <nav className="footer-nav">
          {CONTACT_US && (<a className="footer-link" target="_blank" href={CONTACT_US} rel="noopener noreferrer">
              Contact Us
            </a>)}
          {FACEBOOK && (<a className="footer-link" target="_blank" href={FACEBOOK} rel="noopener noreferrer" aria-label="Facebook">
              <FontAwesomeIcon icon={faFacebookF}/>
            </a>)}
          {/* <a className="footer-link" target="_blank" href={YOUTUBE} rel="noopener noreferrer" aria-label="YouTube">
          <FontAwesomeIcon icon={faYoutube} />
        </a> */}
          {/* <a className="footer-link" target="_blank" href={FACEBOOK} rel="noopener noreferrer" aria-label="Facebook">
          <FontAwesomeIcon icon={faFacebookF} />
        </a> */}
          {/* <a className="footer-link" target="_blank" href={INSTAGRAM} rel="noopener noreferrer" aria-label="Instagram">
          <FontAwesomeIcon icon={faInstagram} />
        </a> */}
          {/* <a className="footer-link" target="_blank" href={TIKTOK} rel="noopener noreferrer" aria-label="TikTok">
          <FontAwesomeIcon icon={faTiktok} />
        </a> */}
          {/* <a className="footer-link" target="_blank" href={LINKEDIN} rel="noopener noreferrer" aria-label="LinkedIn">
          <FontAwesomeIcon icon={faLinkedin} />
        </a> */}
          <LoginLogout className="footer-link"/>
        </nav>
      </div>
    </footer>);
}
export default Footer;
